import { createMuiTheme } from '@material-ui/core';

const theme = createMuiTheme();
const styles = {
    table: {
        minWidth: '100%',
    },
    large: {
        width: theme.spacing(7),
        height: theme.spacing(7),
    },
    tableCellNome: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '100px',
    },
    toolbar: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
        justifyContent: 'flex-start',
    },
    buttonCriar: {
        marginTop: 10,
        color: '#7CB342',
    },
};

export default styles;
